<div class="welcome-header" [style.background-image]="heroBgUrl">
    <div class="welcome-header__banner">
        <p>
            <strong>{{ 'HOME.MOBILE.P_BANNER_STRONG' | translate }}</strong> {{ 'HOME.MOBILE.P_BANNER_DEFAULT' | translate }}
        </p>
    </div>
    <div class="main-container">
        <div class="main-container--title">{{ 'MAIN.TITLE' | translate }}</div>
        <div class="main-container--sub-title">{{ 'MAIN.SUBTITLE' | translate }}</div>
        <app-trip-wizard [mode]="'standalone'"></app-trip-wizard>
        <div class="inner-content-box">
            <button class="hero__content--search btn-default btn-search" (click)="goToPlanningForm()">
                <mat-icon [svgIcon]="eSvgIcons.SEARCH"></mat-icon>
                <span>{{ 'HOME.MOBILE.WHERE_WOULD_YOU_LIKE_TO_GO' | translate }}</span>
            </button>
            <button class="hero__content--start btn-default btn-orange btn-mobile" (click)="goToPlanningForm()">
                {{ 'HOME.MOBILE.START_PLANING' | translate }}
            </button>
        </div>
    </div>
</div>

<div class="welcome-box">
    <div class="rp-trip-planner">
        <div class="rp-trip-planner__header">
            <h1>{{ 'TRIP_PLANNER.TITLE' | translate }}</h1>

            @if (breakpointService.isDesktop()) {
                <p>{{ 'TRIP_PLANNER.DESCRIPTION' | translate }}</p>
            } @else {
                @for (description of ('TRIP_PLANNER.MOBILE.DESCRIPTIONS' | translate); let idx = $index; track idx) {
                    <p [innerHTML]="description | safeHtml"></p>
                }
            }
            <h5>{{ 'TRIP_PLANNER.SUBTITLE_1' | translate }}</h5>
        </div>

        @for (section of ('TRIP_PLANNER.HOW_WORKS' | translate); let idx = $index; track idx) {
            <section class="rp-trip-planner__section">
                <span class="rp-trip-planner__section-count">{{ idx + 1 }}</span>

                <div class="rp-trip-planner__section-text">
                    <p>
                        <span class="strong-highlight">{{ section.title }}</span>
                        <span>{{ section.description }}</span>
                    </p>

                    @for (paragraph of section.paragraphs; track $index) {
                        <p class="rp-trip-planner__section-paragraph">
                            <span>{{ paragraph }}</span>
                        </p>
                    }
                </div>

                <div class="rp-trip-planner__section-media">
                    @for (image of (breakpointService.isDesktop() ? HOW_IT_WORKS_IMAGES[idx] : HOW_IT_WORKS_IMAGES_MOBILE[idx]); let imgIdx = $index; track imgIdx) {
                        @if (breakpointService.isDesktop() && idx === 0) {
                            <app-trip-wizard [mode]="'standalone'"></app-trip-wizard>
                        } @else {
                            <figure>
                                <img
                                        [src]="image.imageUrl | safeUrl"
                                        [style.max-height.px]="image.maxHeight"
                                        [attr.alt]="'tp-empty-' + idx + '-' + imgIdx"
                                        [width]="image.maxWidth"
                                        [height]="image.maxHeight"
                                />
                            </figure>
                        }
                    }
                </div>
            </section>
        }
    </div>
    <div class="rp-trip-planner space">
        <div class="rp-trip-planner__header">
            <h5>{{ 'TRIP_PLANNER.SUBTITLE_2' | translate }}</h5>
        </div>

        @for (section of ('TRIP_PLANNER.CURIOUS_ABOUT' | translate); let idx = $index; track idx) {
            <section class="rp-trip-planner__section"
                     [class.rp-trip-planner__section--full]="breakpointService.isMobile()">
                <div class="rp-trip-planner__section-text">
                    <p>
                        <span class="strong-highlight">{{ section.title }}</span>
                        <span>{{ section.description }}</span>
                    </p>

                    @for (paragraph of section.paragraphs; track $index) {
                        <p class="rp-trip-planner__section-paragraph">
                            <span>{{ paragraph }}</span>
                        </p>
                    }
                </div>

                <div class="rp-trip-planner__section-media">
                    @for (image of CURIOUS_ABOUT_IMAGES[idx]; let imgIdx = $index; track imgIdx) {
                        <figure>
                            <img
                                    [src]="image.imageUrl | safeUrl"
                                    [style.max-height.px]="image.maxHeight"
                                    [attr.alt]="'tp-empty-' + (imgIdx + 1)"
                                    [width]="image.maxWidth"
                                    [height]="image.maxHeight"
                            />
                        </figure>
                    }
                </div>
            </section>
        }
    </div>
</div>

@if (breakpointService.isMobile()) {
    <section class="home-testimonials">
        <app-testimonials
                [title]="'TESTIMONIALS.WHAT_OUT_CUSTOMERS_SAY'"
        ></app-testimonials>
    </section>

    <section class="home-start-planing">
        <app-start-planing-mobile></app-start-planing-mobile>
    </section>
}
